module.exports = __webpack_public_path__ + "img/pr-15.7bc4430a.png";